'use client';

import { useRouter } from 'next/navigation';

const MAX_VISIBLE = 2;
const MAX_CHARS = 10;

interface ListPill {
  collectionId: string;
  collectionTitle: string;
}

interface ListPillsProps {
  lists: ListPill[];
}

export function ListPills({ lists }: ListPillsProps) {
  const router = useRouter();
  if (lists.length === 0) return null;
  const visible = lists.slice(0, MAX_VISIBLE);
  const overflow = lists.length - visible.length;
  return (
    <div className="flex flex-wrap gap-1 mt-1.5" onClick={(e) => e.stopPropagation()}>
      {visible.map((l) => (
        <button
          key={l.collectionId}
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); router.push(`/lists/${l.collectionId}`); }}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs border border-border bg-muted hover:bg-muted/80 transition-colors"
          title={l.collectionTitle}
        >
          {l.collectionTitle.length > MAX_CHARS ? `${l.collectionTitle.slice(0, MAX_CHARS)}…` : l.collectionTitle}
        </button>
      ))}
      {overflow > 0 && (
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs border border-border text-muted-foreground">
          +{overflow} more
        </span>
      )}
    </div>
  );
}
